import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-status-process',
  templateUrl: './card-status-process.component.html',
  styleUrls: ['./card-status-process.component.css']
})

export class CardStatusProcessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
